import clsx from "clsx";
import Image from "next/image";
import Link from "next/link";
import { FC } from "react";
import { Heading } from "@/components/Html/Heading";
import { Tags } from "@/components/Tags/Tags";
import { useHover } from "@/components/useHover";
import { pagesPath } from "@/lib/$path";
import { getImageSize, getImageUrl } from "@/lib/contentful/util";
import { isNonNull } from "@/lib/guard";
import { ResponseBody } from "@/pages/api/fetchRankingData";

interface Props {
  index: number;
  post: ResponseBody;
}

export const Post: FC<Props> = ({ index, post }) => {
  const { isHovered, onMouseEnter, onMouseLeave } = useHover();

  return (
    <div className="relative overflow-hidden rounded-lg border border-gray-pale text-white">
      <Link
        href={pagesPath.kdotdev._slug(post.fields.slug).$url()}
        className="my-2 flex gap-2 px-2"
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <div className="w-[20px] text-right font-semibold leading-5 !no-underline shadow-white text-shadow">
          {index}
        </div>
        <div className="flex flex-1 select-none flex-col gap-[8px]">
          <Heading heading="3" className={clsx("text-sm shadow-white text-shadow", isHovered && "underline")}>
            {post.fields.title}
          </Heading>
        </div>
      </Link>
      <div className="my-2 pl-[36px] pr-2">
        {post.fields.tags && <Tags tags={post.fields.tags.filter(isNonNull)} />}
      </div>
      <div className="absolute left-0 top-0 z-[-1] h-full w-full">
        {post.fields.image ? (
          <Image
            className="absolute -z-10 h-full w-full border-b border-solid border-gray-pale object-cover"
            src={getImageUrl(post.fields.image)}
            width={getImageSize(post.fields.image)?.width}
            height={getImageSize(post.fields.image)?.height}
            alt={String(post.fields.image.fields.title)}
            sizes="(max-width: 768px) 100vw, (max-width: 992px) 250px, 350px"
            quality={40}
          />
        ) : (
          <Image
            className="h-full w-full border-b border-solid border-gray-pale object-cover"
            src="/images/kdotdev/banner.png"
            width={804}
            height={400}
            alt={"Blog Image"}
          />
        )}
        <div className=" h-full w-full bg-black opacity-50" />
      </div>
    </div>
  );
};
